import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4l0 16","key":"svg-0"}],["path",{"d":"M7 12l10 0","key":"svg-1"}],["path",{"d":"M7 4l0 16","key":"svg-2"}]]

const IconLetterH = createReactComponent('outline', 'letter-h', 'LetterH', __iconNode);

export default IconLetterH;